import { useState } from "react";
import {
  linkAdsAccount,
  searchManagerAccounts,
  getGoogleAdsErrorMessage,
} from "../../../../services/ApiService";
import { TableClient } from "./TableClient";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { CommonModal } from "../../../../components/CommonModal";
import { useNavigate } from "react-router-dom";

export const TableAdsAccounts = ({
  customerAccounts,
  apiData,
  setCustomerAccounts,
  fetchAdsAccountStatus,
  setShowAdsAccountsModal,
}) => {
  const [managerResults, setManagerResults] = useState([]);
  const [showClientModal, setShowClientModal] = useState(false);
  const [loading, setLoading] = useState({}); // Change to object to track each button's loading state
  const [managerId, setManagerId] = useState("");
  const user = useSelector((state) => state?.user);
  const navigate=useNavigate()
  const headers = [
    { label: "Sl.No", key: "sl.no" },
    { label: "Manager Account Name", key: "descriptiveName" },
    { label: "Manager", key: "manager" },
    { label: "Actions", key: "actions" },
  ];

  const getManagerAssociatedClientAccounts = async (id, index) => {
    if (!id) {
      toast.error('Invalid manager account ID.');
      return;
    }

    setManagerId(id);
    setLoading((prev) => ({ ...prev, [index]: true }));

    try {
      const data = await searchManagerAccounts(id);
      const results = Array.isArray(data?.[0]?.results) ? data[0].results : [];

      if (results.length > 0) {
        setManagerResults(
          results.map((item) => item?.customerClient).filter(Boolean)
        );
        setShowClientModal(true);
      } else {
        toast.error(
          'No ad accounts found under this manager account. Please verify or contact support for help.'
        );
      }
    } catch (error) {
      toast.error(getGoogleAdsErrorMessage(error, 'Failed to load manager account clients.'));
    } finally {
      setLoading((prev) => ({ ...prev, [index]: false }));
    }
  };

  const handleConnect = async (id, index) => {
    setLoading((prev) => ({ ...prev, [index]: true })); // Set loading for the specific button
    try {
      const data = await linkAdsAccount(null, id, user);
      if (data?.success) {
        toast.success(data?.message);
        setShowAdsAccountsModal(false)
        fetchAdsAccountStatus();
      } else {
        toast.error("Something went wrong");
        setShowAdsAccountsModal(false)
      }
    } catch (error) {
      toast.error("Something went wrong");
      setShowAdsAccountsModal(false)
    } finally {
      setLoading((prev) => ({ ...prev, [index]: false })); // Stop loading
      navigate('/client/settings/integrations')
       setShowAdsAccountsModal(false)
    }
  };

  return (
    <>
      <div className="card-lg  bg-light">
        <div className="table-responsive text-nowrap card-body py-0">
          <table className="table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4 table-auto m-0">
            <thead>
              <tr className="fw-bold text-muted bg-light">
                {headers.map((header) => (
                  <th className={`min-w-100px ${header.label==='Actions'&&'text-end'}`} key={header.key}>
                   {header.label}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {customerAccounts.length === 0 ? (
                <tr>
                  <td
                    colSpan={headers.length}
                    className="text-center text-muted"
                  >
                    No data available
                  </td>
                </tr>
              ) : (
                customerAccounts?.map((account, index) => (
                  <tr className="text-muted" key={index}>
                    <td>{index + 1}</td>
                    <td>{account?.descriptiveName || "---"}</td>
                    <td>{account.manager ? "Yes" : "No"}</td>
                    <td className="d-flex justify-content-end">
                      <button
                        className="btn btn-sm rounded-pill btn-primary   d-flex align-items-center  justify-content-center"
                        style={{width:"150px"}}
                        onClick={() => {
                          account?.manager
                            ? getManagerAssociatedClientAccounts(
                              account.id,
                              index
                            )
                            : handleConnect(account.id, index);
                        }}
                        disabled={loading[index]} // Disable button while loading
                      >
                        {loading[index] ? (
                          <>
                            <span >Please Wait...</span>
                          </>
                        ) : (
                          <span >
                            {account?.manager
                              ? "View client A/c"
                              : "Connect Account"}
                          </span>
                        )}
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
      {showClientModal && (
        <CommonModal
          show={showClientModal}
          setShow={setShowClientModal}
          title={
            <div className="d-flex flex-column gap-1">
              <span className="fs-4 fw-bold">
                Linked Accounts Under This Manager
              </span>
              <small className="fs-8">
                Select an account to proceed with the integration.  <bold> You can link
                  only one account </bold>
              </small>
            </div>
          }
          body={
            <>
              <TableClient
                managerResults={managerResults}
                managerId={managerId}
                setCustomerAccounts={setCustomerAccounts}
                fetchAdsAccountStatus={fetchAdsAccountStatus}
                setShowAdsAccountsModal={setShowAdsAccountsModal}
              />
            </>
          }
        />
      )}
    </>
  );
};
